import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_generic_doc_approval_history_RowClass} from '../../../dbschema';

export class GenericDocApprovalHistoryContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_approval_history: bl_fi_generic_doc_approval_history_RowClass = new bl_fi_generic_doc_approval_history_RowClass();
}
